<template>
    <Header></Header>
    <Navbar href="/" style="max-width: 1400px; margin: auto;">
            <template #back>vers Accueil</template>
            <template #title>Rappel RDV</template>
    </Navbar>
    <section id="rdv-agenda">

        <div class="line_nav_jours">
            <div class="nav_day">
                <div class="nav_day_line">
                    <b>{{ formaterDate(RDV_date) }}</b>
                </div> 
                <div class="nav_day_line">
                    <i @click="change_date('previous')" class="material-icons">chevron_left</i>
                    <a @click="change_date('today')"><span>Aujourd'hui</span></a>
                    <i @click="change_date('next')" class="material-icons">chevron_right</i>
                </div>
            </div>
            <div class="grouped-buttons">
                <button class="btn secondary" @click="fetchAgendaTomorrow">Charger les RDV<i class="material-icons">event_repeat</i></button>
                <button class="btn primary" @click="sendSMS('bulk')" :disabled="loading || selectedCount === 0">
                    Envoyez rappel<i class="material-icons">send</i>
                </button>
                <button
                    class="btn debug"
                    :class="!debug ? 'danger' : 'success'"
                    @click="debug = !debug"
                    v-if="userStore.current_user_groups.includes('ADMIN_PANEL')"
                >
                    Debug&nbsp;{{ debug ? 'ON' : 'OFF' }}
                </button>
            </div>

        </div>

        <div class="stat_grid">
            <!-- Total — carte bordée -->
            <div class="stat_grid_item stat_grid_item--outlined">
                <span class="stat_label">RENDEZ-VOUS</span>
                <span class="big_number">{{ filteredAgenda.length }}</span>
                <span class="stat_sub">programmés</span>
            </div>

            <!-- SMS non envoyé -->
            <div class="stat_grid_item">
                <span class="stat_label">SMS NON ENVOYÉ <span class="dot dot--gray"></span></span>
                <span class="big_number">{{ stats.notSent }}</span>
                <span class="stat_sub">à traiter</span>
            </div>

            <!-- Confirmés -->
            <div class="stat_grid_item">
                <span class="stat_label">CONFIRMÉS <span class="dot dot--green"></span></span>
                <span class="big_number big_number--green">{{ stats.confirmed }}</span>
                <span class="stat_sub">{{ stats.confirmationRate }}% du jour</span>
            </div>

            <!-- En attente -->
            <div class="stat_grid_item">
                <span class="stat_label">EN ATTENTE <span class="dot dot--orange"></span></span>
                <span class="big_number big_number--orange">{{ stats.pending }}</span>
                <span class="stat_sub">SMS envoyé, sans réponse</span>
            </div>

            <!-- Annulés -->
            <div class="stat_grid_item">
                <span class="stat_label">ANNULÉS <span class="dot dot--red"></span></span>
                <span class="big_number big_number--red">{{ stats.cancelled }}</span>
                <span class="stat_sub">à reprogrammer</span>
            </div>

            <!-- Taux de réponse -->
            <div class="stat_grid_item">
                <span class="stat_label">TAUX DE RÉPONSE</span>
                <span class="big_number">{{ stats.responseRate }}<small>%</small></span>
                <span class="stat_sub">
                    <span>dont&nbsp;{{ stats.emailResponseRate }}%&nbsp;par&nbsp;email</span><br>
                    <span>et&nbsp;{{ stats.smsResponseRate }}%&nbsp;par&nbsp;sms</span>
                </span>
            </div>

            <!-- Outils tableau -->
            <div class="tool_grid_item">
                <span class="stat_label">Recherche</span>
                <input type="text" v-model="searchInput">
            </div>
        </div>

        <div class="table">
            <table>
                <thead>
                    <tr>
                        <!-- Selection -->
                        <th>
                            <i class="material-icons interact" @click="toggleSelection">{{ selectionState }}</i>
                        </th>

                        <!-- Horaire -->
                        <th>
                            <div class="filter-tag" @click="nextSort('time')">
                                <span>Horaire</span>
                                <div class="filter-order" >
                                    <i class="material-icons filter-icon" :class="getSortClass('time')">unfold_more</i>
                                </div>
                            </div>
                        </th>

                        <!-- Statut -->
                        <th>
                            <div class="filter-tag" @click="nextSort('statut')">
                                <span>Statut</span>
                                <div class="filter-order">
                                    <i class="material-icons filter-icon" :class="getSortClass('statut')">unfold_more</i>
                                </div>
                            </div>
                        </th>
                        
                        <!-- Commentaire -->
                        <th>Commentaire</th>

                        <!-- Porteur -->
                        <th>
                            <span>Porteur</span>
                        </th>

                        <!-- Rendez-vous -->
                        <th>Rendez-vous</th>

                        <!-- Conseiller -->
                        <th>
                            <div class="filter-tag"  @click="nextSort('conseiller')">
                                <span>Conseiller</span>
                                <div class="filter-order">
                                    <i class="material-icons filter-icon" :class="getSortClass('conseiller')">unfold_more</i>
                                </div>
                            </div>
                        </th>

                        <!-- Rappel RDV -->
                        <th>Rappel RDV</th>

                        <!-- Colonne envoi -->
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="porteur in filteredAgenda" v-if="filteredAgenda.length > 0">
                        <!-- Selection -->
                        <td>
                            <i v-if="canSend(porteur)" class="material-icons interact" @click="toggleRow(porteur)">
                                {{ isSelected(porteur) ? 'check_box' : 'check_box_outline_blank' }}
                            </i>
                            <i v-else class="material-icons" style="opacity: .3">block</i>
                        </td>

                        <!-- Horaire -->
                        <td>
                            <span class="heure">
                                <b>{{ porteur.Dateheuredébutaction.split(' ')[1]}}</b>
                                {{ porteur.Modedintervention }}
                            </span>
                        </td>

                        <!-- Statut -->
                        <td>
                            <div class="grouped-status"
                                @mouseenter="openReasonInfo(porteur, $event)"
                                @mouseleave="showReasonModal = false"
                            >
                                <span class="tag" :class="getRowStatus(porteur)">
                                    <span class="dot"></span>
                                    {{ getRowLabel(porteur) }}
                                </span>
                                <span
                                    v-if="getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.reason"
                                    class="tag cancelled info-icon"
                                ><i class="material-icons">info</i></span>
                            </div>
                        </td>

                        <!-- Commentaire -->
                        <td>
                            <textarea
                                rows="1"
                                :value="commentaries[`${date_to_lookup}:${porteur.Idaction}:${porteur.NuméroIDduporteur}`] ?? ''"
                                @input="commentaries[`${date_to_lookup}:${porteur.Idaction}:${porteur.NuméroIDduporteur}`] = $event.target.value"
                            ></textarea>
                        </td>

                        <!-- Porteur -->
                        <td>
                            <span class="porteur">
                                <b>{{ porteur.Nom }}&nbsp;{{ porteur.Prénom }}</b>
                                {{ cleanPhoneNumber(porteur.Numérotéléphonebureau) }}
                            </span>
                            <div v-if="porteur.Siret != '(pas de valeur)' || porteur.Immatricule === 'oui'">
                                <br>
                                <span class="tag immatricule">
                                    <span class="dot"></span>
                                    Immatriculé
                                </span>
                            </div>
                        </td>

                        <!-- Rendez-vous -->
                        <td>
                            <span class="rendezvous">
                                <b>
                                    {{ porteur.Typedaction }}
                                </b>
                                {{ porteur.Lieudaction }}
                            </span>

                        </td>

                        <!-- Conseiller -->
                        <td>
                            <div class="conseiller">
                                <span class="badge" :style="{'background-color': intervenantColors[porteur.IntervenantBGE]}">
                                    {{ porteur.IntervenantBGE.split(' ')[0][0]
                                    + porteur.IntervenantBGE.split(' ')[1][0]}}
                                </span>
                                {{ porteur.IntervenantBGE }}
                            </div>
                        </td>

                        <!-- Rappel RDV -->
                        <td>
                            <span class="rappel" v-if="getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.sent_timestamp">
                                Envoyé - {{ formatDate(getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.sent_timestamp) }}
                            </span>
                            <template v-if="getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.responded_at">
                                <span class="rappel2">Répondu - {{ formatDate(getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.responded_at) }}</span>
                                <span class="rappel2 uppercase">{{ getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.channel }}</span>
                            </template>
                            <span class="rappel2" v-else>
                                Pas de réponse
                            </span>
                        </td>

                        <!-- Colonne envoi -->
                        <td>
                            <div class="action">
                                <button
                                    v-if="!getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.sent_timestamp"
                                    class="btn primary"
                                    :disabled="loading || !canSend(porteur)"
                                    @click="sendSMS('single', porteur)"
                                >Envoyer</button>
                            
                                <button
                                    v-else
                                    class="renvoyer"
                                    :disabled="loading || !canSend(porteur)"
                                    @click="sendSMS('single', porteur)"
                                >Renvoyer</button>
                            
                                <i class="material-icons">chevron_right</i>
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>

    </section>

    <Modal v-model="showModal">
        <div class="modal-display">
            <i class="material-icons icon">report_problem</i>
            <h2>SMS déjà envoyés&nbsp;!</h2>
            <p v-if="freshCount > 0">Des SMS ont déjà été envoyés à un ou plusieurs destinataires de cette sélection. Souhaitez-vous renvoyer les messages ou limiter l'envoi aux nouveaux destinataires ?</p>
            <p v-else>Des SMS ont déjà été envoyés à tous les destinataires de cette sélection. Souhaitez-vous les renvoyer ?</p>
        
            <div class="grouped-buttons">
                <button v-if="freshCount > 0" class="btn primary" @click="sendSMS('bulk_fresh')" :disabled="loading">Nouveaux uniquement ({{ freshCount }})</button>
                <button class="btn secondary" @click="sendSMS('bulk_force')" :disabled="loading">Renvoyer</button>
                <button class="btn tertiary" @click="showModal = false">Annuler</button>
            </div>
        </div>
    </Modal>

    <Modal v-model="showSingleModal">
        <div class="modal-display">
            <i class="material-icons icon">report_problem</i>
            <h2>SMS déjà envoyé&nbsp;!</h2>
            <p>
                Un SMS a déjà été envoyé à
                <strong>{{ pendingSinglePorteur?.Prénom }} {{ pendingSinglePorteur?.Nom }}</strong>.
                Souhaitez-vous le renvoyer&nbsp;?
            </p>
            <div class="grouped-buttons">
                <button class="btn primary" @click="sendSMS('single_force')" :disabled="loading">Renvoyer</button>
                <button class="btn secondary" @click="showSingleModal = false">Annuler</button>
            </div>
        </div>
    </Modal>

    <BubblePopup v-model="showReasonModal" :anchor="anchorRect" tail="left">
        <div class="modal-display text-start">
            <section>
                <h2>Rendez-vous annulé</h2>
                <article class="article-section">
                    <h3>Raison</h3>
                    <p>{{ getConfirmation(selectedPorteur.NuméroIDduporteur, selectedPorteur.Idaction)?.reason?.cancel_reason }}</p>
                </article>
                <article class="article-section" v-if="getConfirmation(selectedPorteur.NuméroIDduporteur, selectedPorteur.Idaction)?.reason?.cancel_description">
                    <h3>Description</h3>
                    <p>{{ getConfirmation(selectedPorteur.NuméroIDduporteur, selectedPorteur.Idaction)?.reason?.cancel_description }}</p>
                </article>
            </section>
        </div>
    </BubblePopup>
</template>

<script setup>
    import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
    import apiClient                                        from '@/api'
    import Header                                           from '@/components/Header.vue'
    import Navbar                                           from '@/components/Navbar.vue'
    import { useUserStore }                                 from '@/stores/userstore'
    import Modal                                            from '@/components/Modal.vue'
    import BubblePopup                                      from '@/components/BubblePopup.vue'
    import { colorPalette }                                 from '../assets/colors'
    import { useDebounceWatch }                             from '@/composables/useDebounchWatch'

    const userStore = useUserStore()

    const agenda                    = ref([])
    const today                     = new Date().toISOString().split("T")[0];
    const tomorrow                  = ref(null)
    const date_to_lookup            = ref(null)
    const RDV_date                  = ref(null)
    const RDV_date_jour             = ref(null)
    const debug                     = ref(false)
    const replies                   = ref([])
    const showModal                 = ref(false)
    const showSingleModal           = ref(false)
    const showReasonModal           = ref(false)
    const pendingSinglePorteur      = ref(null)
    const selectedPorteur           = ref(null)
    const anchorRect                = ref(null)
    const loading                   = ref(false)
    const commentaries              = ref({})
    const prevCommentaries          = ref({})

    const sortBy                    = ref(['conseiller', 'time'])
    const sortDirection             = ref({ time: 'asc', statut: 'asc', conseiller: 'asc' })
    const searchInput               = ref('')
    const debouncedSearch           = ref('')

    const selectedIds               = ref(new Set())

    function setSort(key, direction) {
        if (direction === null) {
            sortBy.value = sortBy.value.filter(k => k !== key)
            sortDirection.value[key] = 'asc'
        } else {
            const priority = ['conseiller', 'statut', 'time']
            sortDirection.value[key] = direction
            
            const active = new Set([...sortBy.value, key])
            sortBy.value = priority.filter(k => active.has(k))
        }
    }

    function nextSort(key) {
        const current = sortBy.value.includes(key) ? sortDirection.value[key] : null

        if (key === 'time') {
            setSort(key, current === 'asc' ? 'desc' : 'asc')
        } else {
            if (current === null)       setSort(key, 'asc')
            else if (current === 'asc') setSort(key, 'desc')
            else                        setSort(key, null)
        }
    }

    function getSortClass(key) {
        if (!sortBy.value.includes(key)) return null

        return sortDirection.value[key]
    }

    const isCancelledWithReply = (p) => {
        const c = getConfirmation(p.NuméroIDduporteur, p.Idaction)
        return c?.confirmation === true || c?.confirmation === false
    }

    const baseAgenda = computed(() => {
        if (!agenda.value[0]) return []

        return agenda.value
            .filter(item => 
                item.Nom                                                    &&
                item.Nom !== '(pas de valeur)'                              &&
                item.Modedintervention !== 'Sur dossier'                    &&
                item.Naturedaction                                          &&
                (
                    item.Naturedaction !== 'Collective'                     ||
                    (item.Offredeservicedelaction || '').includes('EMG')
                )                                                           &&
                !['Absence', 'Administrative'].includes(item.Naturedaction) &&
                (
                    !debouncedSearch.value ||
                    item.Nom.toLowerCase().includes(debouncedSearch.value.toLowerCase())                    ||
                    item.Prénom.toLowerCase().includes(debouncedSearch.value.toLowerCase())                 ||
                    item.Numérotéléphonebureau.toLowerCase().includes(debouncedSearch.value.toLowerCase())  ||
                    item.Dateheuredébutaction.toLowerCase().includes(debouncedSearch.value.toLowerCase())   ||
                    item.Modedintervention.toLowerCase().includes(debouncedSearch.value.toLowerCase())      ||
                    item.Typedaction.toLowerCase().includes(debouncedSearch.value.toLowerCase())            ||
                    item.Lieudaction.toLowerCase().includes(debouncedSearch.value.toLowerCase())            ||
                    item.IntervenantBGE.toLowerCase().includes(debouncedSearch.value.toLowerCase())
                )
            )
            .sort((a, b) => {
                for (const key of sortBy.value) {
                    let comparison = 0

                    if (key === 'time') {
                        const d1 = parseFrDateTime(a.Dateheuredébutaction)
                        const d2 = parseFrDateTime(b.Dateheuredébutaction)
                        
                        comparison = d1 - d2
                    } else if (key === 'conseiller') {
                        comparison = a.IntervenantBGE.localeCompare(b.IntervenantBGE, 'fr')
                    } else if (key === 'statut') {
                        const order = { 'not-sent': 0, 'pending': 1, 'confirmed': 2, 'cancelled': 3 }
                        const s1 = order[getRowStatus(a)] ?? 99
                        const s2 = order[getRowStatus(b)] ?? 99
                        comparison = s1 - s2
                    }

                    if (comparison !== 0) return sortDirection.value[key] === 'asc' ? comparison : -comparison
                }

                return 0
            })
            .map(({
                Dateheuredébutaction,
                Idaction,
                NuméroIDduporteur,
                Nom,
                Prénom,
                Numérotéléphonebureau,
                Email,
                Modedintervention,
                Durée,
                Lieudaction,
                Typedaction,
                Naturedaction,
                IntervenantBGE,
                Siret,
                Immatricule,
                Statutdelaction
            }) => ({
                Dateheuredébutaction,
                Idaction,
                NuméroIDduporteur,
                Nom,
                Prénom,
                Numérotéléphonebureau,
                Email,
                Modedintervention,
                Durée,
                Lieudaction,
                Typedaction,
                Naturedaction,
                IntervenantBGE,
                Siret,
                Immatricule,
                Statutdelaction
            }))
    })

    const filteredAgenda = computed(() =>
        (baseAgenda.value ?? []).filter(p => isHeld(p) || isCancelledWithReply(p))
    )

    const isHeld = (p) => p.Statutdelaction !== 'Non tenue'

    const getRowStatus = (p) => {
        if (!isHeld(p)) return 'cancelled'

        return getConfirmationStatus(p.NuméroIDduporteur, p.Idaction)
    }

    const getRowLabel = (p) => {
        const c = getConfirmation(p.NuméroIDduporteur, p.Idaction)

        if (c?.sent_timestamp && c.confirmation === false) return 'Annulé'
        if (!isHeld(p)) return 'Annulé'

        return getConfirmationLabel(p.NuméroIDduporteur, p.Idaction)
    }

    const canSend = (p) => {
        if (!isHeld(p)) return false

        const status = getConfirmationStatus(p.NuméroIDduporteur, p.Idaction)
        return status === 'not-sent' || status === 'pending'
    }

    const sendableAgenda = computed(() => filteredAgenda.value.filter(canSend))

    const selectedCount = computed(() =>
        sendableAgenda.value.filter(p => isSelected(p)).length
    )

    const freshCount = computed(() =>
        sendableAgenda.value.filter(p =>
            isSelected(p) && !getConfirmation(p.NuméroIDduporteur, p.Idaction)?.sent_timestamp
        ).length
    )

    const stats = computed(() => {
        const list = filteredAgenda.value

        let totalSent   = 0
        let confirmed   = 0
        let cancelled   = 0
        let pending     = 0
        let notSent     = 0
        let responded   = 0

        let emailSent       = 0
        let emailResponded  = 0
        let smsSent         = 0
        let smsResponded    = 0

        for (const p of list) {
            const c = getConfirmation(p.NuméroIDduporteur, p.Idaction)

            const notHeld = !isHeld(p)
            const replied = c?.confirmation === true || c?.confirmation === false

            if (!c?.sent_timestamp) {
                notSent++
                continue
            }

            totalSent++

            const isEmail   = c.channel === 'email'
            const isSms     = c.channel === 'sms'

            if (isEmail) emailSent++
            if (isSms)   smsSent++

            // Responses (for the response rate)
            if (c.confirmation === true || c.confirmation === false) {
                responded++
                if (isEmail) emailResponded++
                if (isSms)   smsResponded++
            }

            // Status: only direct responses count as confirmed / cancelled
            if (c.confirmation === false)       cancelled++
            else if (c.confirmation === true)   confirmed++
            else                                pending++
        }

        const responseRate      = totalSent ? Math.round((responded         / totalSent) * 100) : 0
        const confirmationRate  = totalSent ? Math.round((confirmed         / totalSent) * 100) : 0
        const emailResponseRate = responded ? Math.round((emailResponded    / responded) * 100) : 0
        const smsResponseRate   = responded ? Math.round((smsResponded      / responded) * 100) : 0
        const otherResponseRate = responded ? Math.round(((responded - emailResponded - smsResponded) / responded) * 100) : 0

        return {
            total: list.length,
            totalSent,
            confirmed,
            cancelled,
            pending,
            notSent,
            responseRate,
            confirmationRate,
            emailResponseRate,
            smsResponseRate,
            otherResponseRate,
            emailResponded,
            smsResponded,
        }
    })

    // Color name tags
    const intervenantColorCache = new Map()

    const intervenantColors = computed(() => {
        const map = {}
        for (const item of filteredAgenda.value) {
            if (item.IntervenantBGE && !map[item.IntervenantBGE]) {
                map[item.IntervenantBGE] = nameToColor(item.IntervenantBGE)
            }
        }
        return map
    })

    function nameToColor(fullName) {
        if (intervenantColorCache.has(fullName)) {
            return intervenantColorCache.get(fullName)
        }

        const usedColors = new Set(intervenantColorCache.values())
        const color = colorPalette.find(c => !usedColors.has(c)) ?? colorPalette[0]

        intervenantColorCache.set(fullName, color)
        return color
    }
    // End color name tags

    const repliesMap = computed(() => {
        const map = new Map()

        for (const r of replies.value) {
            map.set(`${r.date}:${r.id_action}:${r.id_porteur}`, r)
        }

        return map
    })

    const getConfirmation = (id_porteur, id_action, date = date_to_lookup.value) => {
        return repliesMap.value.get(`${date}:${id_action}:${id_porteur}`)
    }

    const getConfirmationLabel = (id_porteur, id_action) => {
        const confirmation = getConfirmation(id_porteur, id_action)

        if (!confirmation?.sent_timestamp) {
            return 'Non envoyé'
        }

        if (confirmation?.sent_timestamp) {
            if (confirmation.confirmation === true)     return 'Confirmé'
            if (confirmation.confirmation === false)    return 'Annulé'
            if (confirmation.confirmation == null)      return 'En attente'
        }

        return '-'
    }

    const getConfirmationStatus = (id_porteur, id_action) => {
        const confirmation = getConfirmation(id_porteur, id_action)

        if (!confirmation?.sent_timestamp) {
            return 'not-sent'
        }

        if (confirmation?.confirmation === true)   return 'confirmed'
        if (confirmation?.confirmation === false)  return 'cancelled'
        if (confirmation?.confirmation == null)    return 'pending'
    }

    function parseFrDateTime(str) {
        if (!str) return new Date(0); // fallback to epoch

        const [datePart, timePart] = str.split(' ');
        const [day, month, year]   = datePart.split('/');
        const [hour, minute]       = timePart.split(':');

        return new Date(
            parseInt(year),
            parseInt(month) - 1, // JavaScript months are 0-based
            parseInt(day),
            parseInt(hour),
            parseInt(minute)
        )
    }

    function formatDate(unformatted_date) {
        const date = new Date(unformatted_date)

        if (isNaN(date.getTime()) || unformatted_date == null) return '-'

        return date.toLocaleString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            // year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            // second: '2-digit'
        })
    }

    const fetchAgendaTomorrow = () => {

        window.postMessage({
            type: 'fetchAgendaTomorrow',
            startDate: RDV_date.value,
            endDate: RDV_date.value
        }, '*');

    }

    const get_agenda = async (date = date_to_lookup.value) => {
        try {
            const response = await apiClient.get('/get_last_agenda_rdv/', {
                params: {
                    date: date
                }
            })

            agenda.value = cleanClientDataKeys(response.data.data)

            const seen = new Set()

            agenda.value = agenda.value.filter(item => {
                const key = `${item.NuméroIDduporteur}-${item.Idaction}`

                if (seen.has(key)) return false
                seen.add(key)
                return true
            })

            await fetchConfirmation()
        } catch (e) {
            agenda.value = []
            if (e.status !== 404) console.error("Erreur: ", e)
        }
    }

    
    function formatLocalDate(date) {

        const pad = (n) => String(n).padStart(2, '0')

        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    }

    function formaterDate(dateStr) {
        if (!dateStr) return ''   // ← garde null/undefined
        
        const [j, m, a] = dateStr.split('/').map(Number)
        const formatee = new Intl.DateTimeFormat('fr-FR', {
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
        }).format(new Date(a, m - 1, j))
        
        return formatee.replace(/(^|\s)\p{L}/gu, c => c.toUpperCase())
    }

    function change_date(action) {

        const current = new Date(date_to_lookup.value)

        if (action === "today") {

            date_to_lookup.value = today

        } else if (action === "previous") {

            if (RDV_date_jour.value === 'LUNDI') {
                current.setDate(current.getDate() - 3)
            } else {
                current.setDate(current.getDate() - 1)
            }

            date_to_lookup.value = formatLocalDate(current)

        } else if (action === "next") {

            if (RDV_date_jour.value === 'VENDREDI') {
                current.setDate(current.getDate() + 3)
            } else {
                current.setDate(current.getDate() + 1)
            }

            date_to_lookup.value = formatLocalDate(current)

        } else {
            console.log("Invalid action:", action)
        }

        get_agenda()
    }

    //FONCTION de nettoyage des charactèress spéciaux
    function fixEncoding(str) {
        if (typeof str !== 'string') return str;
        return str
            .replace(/â/g, '’')
            .replace(/â/g, '–')
            .replace(/â”/g, '—')
            .replace(/â¦/g, '…')
            .replace(/Ã©/g, 'é')
            .replace(/Ã¨/g, 'è')
            .replace(/Ãª/g, 'ê')
            .replace(/Ã€/g, 'À')
            .replace(/Ã/g, 'à')
            .replace(/Ã´/g, 'ô')
            .replace(/Ã¢/g, 'â')
            .replace(/Ã¹/g, 'ù')
            .replace(/Ã»/g, 'û')
            .replace(/Ã§/g, 'ç')
            .replace(/Â/g, '')
            .replace(/à®/g,'î')
    }
    
    // FONCTION de nettoyage des clés
    function cleanClientDataKeys(dataArray) {
        return dataArray.map((obj) => {
            const cleanedObj = {};
            Object.keys(obj).forEach((key) => {
                const cleanKey = key
                .replace(/(^\s+|\s+$)/g, '')  // Trim leading/trailing whitespace
                .replace(/\s+/g, '')          // Remove all internal whitespace
                .replace(/[()]/g, '')
                .replace(/-/g,'')
                .replace(/\//g, '')
                .replace(/'/g,'');
                cleanedObj[cleanKey] = fixEncoding(obj[key]);    });
            return cleanedObj;
        });
    }

    // FONCTION nettoyage du numéro de téléphone
    function cleanPhoneNumber(phone) {
        if (!phone) return null

        const digitsOnly = phone.replace(/\D/g, '')

        if (digitsOnly.length < 10) return null

        return digitsOnly.slice(0, 10).replace(/(\d{2})(?=\d)/g, '$1 ')
    }

    const handleMessage = async (event) => {

        if (event.data?.type === 'agendaData' && Array.isArray(event.data.data)) {

            const formData = new FormData()

            formData.append("payload", JSON.stringify(event.data.data))
            formData.append("agenda_date", date_to_lookup.value)

            try {
                await apiClient.post('/update_agenda_rdv/', formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                })
                await get_agenda(date_to_lookup.value)

            } catch (e) {
                console.error('Erreur: ', e)
            }
        }
    }

    const sendSMS = async (mode, porteur) => {
        try {
            let payload = null

            if (mode === 'bulk') {
                const selected = sendableAgenda.value.filter(p => isSelected(p))
                payload = selected

                const alreadySent = selected.filter(p => getConfirmation(p.NuméroIDduporteur, p.Idaction)?.sent_timestamp)

                if (alreadySent.length > 0) {
                    showModal.value = true
                    return
                }
            } else if (mode === 'bulk_force') {
                
                payload = sendableAgenda.value.filter(p => isSelected(p))

            } else if (mode === 'bulk_fresh') {
                
                payload = sendableAgenda.value.filter(p => isSelected(p)).filter(p =>
                    !getConfirmation(p.NuméroIDduporteur, p.Idaction)?.sent_timestamp
                )

            } else if (mode === 'single') {
                if (!canSend(porteur)) return

                if (getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.sent_timestamp) {
                    pendingSinglePorteur.value  = porteur
                    showSingleModal.value       = true
                
                    return
                }

                payload = [porteur]

            } else if (mode === 'single_force') {
                payload                     = [pendingSinglePorteur.value].filter(p => p && canSend(p))
                showSingleModal.value       = false
                pendingSinglePorteur.value  = null
            }

            if (!payload?.length) {
                showModal.value = false
                return
            }

            showModal.value = false
            loading.value   = true

            const response = await apiClient.post('/send_sms/', {
                agenda: payload,
                debug: debug.value
            })
            
            console.log(response.data)

            await fetchConfirmation()
        } catch (e) {
            console.error(e)
        }

        loading.value = false
    }

    const saveCommentary = async (compositeKey, value) => {
        const [date, idAction, idPorteur] = compositeKey.split(':')
        const porteur = filteredAgenda.value.find(p => 
            p.Idaction === idAction && p.NuméroIDduporteur === idPorteur
        )
    
        try {
            await apiClient.post('/save_commentary/', {
                id:         compositeKey,
                commentary: value,
                porteur:    porteur
            })
        } catch (e) {
            console.error(e)
        }
    }

    function openReasonInfo(porteur, event) {
        if (!getConfirmation(porteur.NuméroIDduporteur, porteur.Idaction)?.reason) return

        anchorRect.value = event.currentTarget.getBoundingClientRect()

        showReasonModal.value = true

        selectedPorteur.value = porteur
    }

    function fetchTimer() {
        console.log('Fetched Confirmation...')
        fetchConfirmation()
    }

    const fetchConfirmation = async () => {
        try {
            const porteurIDs = baseAgenda.value.map(item => item["NuméroIDduporteur"])
            const response = await apiClient.post('/get_rdv_confirmations/', {
                id_porteurs: porteurIDs,
                date: date_to_lookup.value
            })

            replies.value = response.data

            for (const p of baseAgenda.value) {
                const confirmation = getConfirmation(p.NuméroIDduporteur, p.Idaction)

                // Patch immatricule from confirmation data back into agenda
                if (confirmation?.data?.Immatricule) {
                    const agendaItem = agenda.value.find(
                        a => a.NuméroIDduporteur === p.NuméroIDduporteur && a.Idaction === p.Idaction
                    )
                    if (agendaItem) agendaItem.Immatricule = confirmation.data.Immatricule
                }

                if (confirmation?.commentary) {
                    const key = `${date_to_lookup.value}:${p.Idaction}:${p.NuméroIDduporteur}`
                    commentaries.value[key]     = confirmation.commentary
                    prevCommentaries.value[key] = confirmation.commentary
                }
            }
        } catch (e) {
            console.error(e)
        }
    }

    const selectionState = computed(() => {
        const total    = sendableAgenda.value.length
        const selected = selectedIds.value.size

        if (total === 0)        return 'check_box'
        if (selected === 0)     return 'check_box_outline_blank'
        if (selected === total) return 'check_box'

        return 'indeterminate_check_box'
    })

    const toggleSelection = () => {
        if (selectionState.value === 'check_box') {
            selectedIds.value = new Set()
        } else {
            selectedIds.value = new Set(
                sendableAgenda.value.map(p => `${p.NuméroIDduporteur}-${p.Idaction}`)
            )
        }
    }

    const isSelected = (porteur) => selectedIds.value.has(`${porteur.NuméroIDduporteur}-${porteur.Idaction}`)

    const toggleRow = (porteur) => {
        if (!canSend(porteur)) return

        const key = `${porteur.NuméroIDduporteur}-${porteur.Idaction}`
        const next = new Set(selectedIds.value)
        next.has(key) ? next.delete(key) : next.add(key)
        selectedIds.value = next
    }

    watch(date_to_lookup, () => {
        const date = new Date(date_to_lookup.value)

        RDV_date.value = date.toLocaleDateString('fr-FR')
        RDV_date_jour.value = date.toLocaleDateString('fr-FR', {
        weekday: 'long'}).toUpperCase()
    })

    useDebounceWatch(searchInput, async () => {
        debouncedSearch.value = searchInput.value
        await fetchConfirmation()
    })

    useDebounceWatch(commentaries, (newVal) => {
        for (const idAction in newVal) {
            if (newVal[idAction] !== prevCommentaries.value[idAction]) {
                saveCommentary(idAction, newVal[idAction])
                prevCommentaries.value[idAction] = newVal[idAction]
            }
        }
    }, 500, { deep: true })

    watch(sendableAgenda, (newList, oldList) => {
        const oldKeys = new Set(oldList?.map(p => `${p.NuméroIDduporteur}-${p.Idaction}`) ?? [])
        const newKeys = new Set(newList.map(p => `${p.NuméroIDduporteur}-${p.Idaction}`))
        const next    = new Set(
            [...selectedIds.value].filter(k => newKeys.has(k))
        )

        for (const p of newList) {
            const key = `${p.NuméroIDduporteur}-${p.Idaction}`
            if (!oldKeys.has(key)) next.add(key)
        }

        selectedIds.value = next
    }, { immediate: true })
    
    let fetchIntervalId = null

    onMounted(() => {
        date_to_lookup.value = today

        const todayDate     = new Date()
        const tomorrowDate  = new Date()

        tomorrowDate.setDate(todayDate.getDate() + 1)
        tomorrow.value = tomorrowDate.toLocaleDateString('fr-FR')
        get_agenda()
        window.addEventListener('message', handleMessage)

        fetchIntervalId = setInterval(() => {
            fetchTimer()
        }, 10 * 1_000)
    })

    onUnmounted(() => {
        window.removeEventListener('message', handleMessage)
        
        clearInterval(fetchIntervalId)
    })
</script>

<style lang="scss" scoped>


// NAVIGATION DES JOURS

.line_nav_jours{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    max-width: 1400px;
    margin: auto;

    .nav_day{
        background-color: white;
        border-radius: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        gap: 1rem;
    }

    .nav_day_line{
        display: flex;
        flex-direction: row;
        font-size:medium;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        i{
            background-color: #f4f7fa;
            border-radius: 5px;
            cursor: pointer;
            &:hover{
                background-color: $gray;
            }
        }
        a{
            cursor: pointer;
            &:hover{
                text-decoration: underline;
            }
        }
    }
}


// GRILLE DES STATS
.stat_grid {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    gap: 12px;
    max-width: 1400px;
    margin: auto;
    margin-top: 1rem;
}

.stat_grid_item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px 20px;
    border-radius: 12px;
    background: #fff;
    min-width: 130px;
}

.tool_grid_item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px 20px;
    border-radius: 12px;
    background: #fff;
    width: 100%;
}

.stat_grid_item--outlined {
    border: 1.5px solid #d0d0d0;
}

.stat_label {
    font-size: 11px;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    display: flex;
    align-items: center;
    gap: 6px;
}

.big_number {
    font-size: 2rem;
    line-height: 1;
    color: #1a1a1a;
}
.big_number small { font-size: 18px; font-weight: 500; }

.big_number--green  { color: #2e7d32; }
.big_number--orange { color: #e65100; }
.big_number--red    { color: #c62828; }

.stat_sub {
    font-size: 12px;
    color: #666;
}

/* Dots */
.dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.dot--green  { background: #43a047; }
.dot--orange { background: #fb8c00; }
.dot--red    { background: #e53935; }
.dot--gray   { background: #9e9e9e; }


.table{
    max-width: 1600px;
    margin: auto;
    margin-top: 1rem;
    background-color: white;

    table{
        border: 1px solid #e0e5ea;
        font-size: smaller;
        th{
            background-color: #f4f7fa;
            color: #70757a;
            border: none;
            font-size: medium;
            font-weight: 400;
            text-transform: uppercase;
        }
    }
    td{
        border: 1px solid #e0e5ea;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .heure{
        display: flex;
        flex-direction: column;
        color: #70757a;
        b{
            color: #1a1a1a;
        }
    }

    .porteur{
        display: flex;
        flex-direction: column;
        color: #70757a;
        b{
            color: #1a1a1a;
            font-size: smaller;
            font-weight: 600;
        }
    }

    .conseiller{
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
        .badge{
            background-color: $pale-orange;
            padding: 0.5rem;
            border-radius: 45px;
            width: 1.2rem;
            text-align: center;
        }
    }

    .rendezvous,.rappel,.rappel2{
        display: flex;
        flex-direction: column;
        color: #70757a;
        font-size: smaller;
        b{
            color: $night-blue;
            font-weight: 400;
        }
    }

    .rappel2{
        opacity: 0.8;
    }


    .action{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .material-icons{
            font-weight: 100;
            font-size: small;
        }
    }
    .renvoyer {
        background: none;
        border: none;
        padding: 0;
        font: inherit;
        cursor: pointer;
        text-decoration: underline;

        &:disabled {
            opacity: .4;
            cursor: not-allowed;
            text-decoration: none;
        }
    }
}

#rdv-agenda {
    table {
        td {
            text-wrap: nowrap;
        }
    }

    .text-center {
        text-align: center;
    }
    
    .tag {
        border-radius: 15px;
        padding: 4px 12px;
        font-weight: 600;

        -webkit-user-select: none; /* Chrome, Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge legacy */
        user-select: none;         /* Standard */

        .dot {
            margin-right: .25rem;
        }

        &.immatricule {
            background-color: rgba($dark-blue, .2);
            color: dark-blue;
        }
    
        &.confirmed {
            background-color: rgba($green, .2);
            color: $dark-green;
        
            .dot {
                background-color: $dark-green;
            }
        }
        
        &.cancelled {
            background-color: rgba($darkred, .2);
            color: $darkred;

            .dot {
                background-color: $darkred;
            }

            &:hover {
                cursor: help;
            }
        }
        
        &.pending {
            background-color: rgba($orange, .2);
            color: #9b680b;

            .dot {
                background-color: $orange;
            }
        }
        
        &.not-sent {
            background-color: rgba($gray, .5);
            color: $dark-gray;
        }

        .dot {
            background-color: $dark-gray;
        }

        &.info-icon {
            padding: 0;
            margin: 0;

            display: flex;
            justify-content: center;
        }
    }

    .row {
        &.confirmed {
            background-color: rgba($green, .15);
        }
        
        &.cancelled {
            background-color: rgba($darkred, .15);
        }
    }
}

.grouped-buttons {
    display: flex;
    gap: 1rem;
}

.btn{
    background-color: transparent;
    border: 2px solid transparent;
    box-sizing: border-box;
    color: white;
    padding: 0.4rem;
    border-radius: 10px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;

    
    &.primary {
        background-color: $night-blue;
    }
    
    &.secondary {
        border-color: $night-blue;
        color: $night-blue;
    }

    &.tertiary {
        color: $night-blue;
        text-decoration: underline;
    }

    &.debug {
        width: 100px;
    }

    &.danger {
        background-color: $darkred;
    }

    &.success {
        background-color: $dark-green;
    }

    &:hover {
        background-color: $dark-blue;
        border-color: transparent;
        color: $white;
        text-decoration: none;
    }

    &:disabled {
        background-color: $gray;

        cursor: no-drop;
    }
}

.modal-display {
    width: 400px;

    text-align: center;

    .grouped-buttons {
        display: flex;
        justify-content: center;
        gap: 1rem;

        margin-top: 2rem;
    }

    i {
        font-size: 5rem;
        color: $night-blue;
    }

    &.text-start {
        text-align: start;
    }
}

.article-section {
    text-align: start;

    border-top: 2px solid $gray;
}

.justify-center {
    display: flex;
    justify-content: center;
}

.grouped-status {
    display: inline-flex;
    gap: .5rem;
}

.filter-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: auto;

    cursor: pointer;
    -webkit-user-select: none; /* Chrome, Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* IE/Edge legacy */
    user-select: none;         /* Standard */

    &:has(.filter-options):hover {
        i {
            color: $orange;
        }
    }
}

.filter-order {
    display: flex;
    flex-direction: column;
    
    .filter-icon {
        background: $gray;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        &.asc {    
            background: linear-gradient(to bottom,$orange 0% 50%,$gray 50% 100%);
            
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        
        &.desc {    
            background: linear-gradient(to top,$orange 0% 50%,$gray 50% 100%);

            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .filter-options {
        font-size: 1.2rem;
        color: $gray;
    }
}

textarea {
    resize: vertical;
    min-height: 2em;
}

.uppercase {
    text-transform: uppercase;
}

.interact {
    cursor: pointer;
}
</style>